import axios from "axios";
//export const BASE_URL = "http://localhost:5200";
//export const BASE_URL = "http://192.168.1.17:5053";
export const BASE_URL = "https://jobtreeapi.agsapplications.com";

export default axios.create({
  baseURL: BASE_URL,
});

export const axiosAuth = axios.create({
  baseURL: BASE_URL,
  headers: { ContentType: "application/json" },
  withCredentials: true,
});
